import { WeatherMode } from "features/map/control/types"
import { useViewport } from "features/map/GlobalViewState"
import { WindHeatmapLegend } from "../wind/WindHeatmapLegend"
import { PrecipitationLegend } from "../precipitation/PrecipitationLegend"
import { RadarLegend } from "../radar/RadarLegend"
import { LightningRiskLegend } from "../lightning/LightningRiskLegend"

type Props = { mode: WeatherMode; isLight: boolean }

export const WeatherLegend = ({ mode, isLight }: Props) => {
    const viewport = useViewport()
    switch (mode) {
        case "wind":
            return <WindHeatmapLegend isLight={isLight} />
        case "precipitation":
            return <PrecipitationLegend isLight={isLight} />
        case "radar":
            return <RadarLegend isLight={isLight} />
        case "lightning":
            return <LightningRiskLegend zoom={viewport.zoom} isLight={isLight} />
        default:
            return null
    }
}
